<template>
  <div style="height: 100%; width: 100%; display: flex; flex-direction: column;">
    <div style="position: relative; flex: 1 1 0; min-height: 0;">
    <div ref="map-root" style="height: 100%; width: 100%;"></div>
    <div
      v-if="isPalette && activePalette && activePalette.colors && activePalette.colors.length && isIDWOn && !isProfilingRoute"
      class="map-palette-overlay"
      style="position: absolute; top: 115px; right: 8px; z-index: 1000; padding: 6px 8px 15px 8px; background: rgba(255,255,255,0.85); border-radius: 4px; box-shadow: 0 1px 4px rgba(0,0,0,0.2); width: 100px;"
    >
      <ColorPalette
        :colors="activePalette.colors"
        :numbers="activePalette.numbers"
        :signature-text="activePalette.signature"
        layout="vertical"
        :height="500"
        :palette-width="30"
        :text-size="14"
        text-color="#333"
      />
    </div>
    <div
      v-if="areaPreviewRequest && areaPreviewRequest.active"
      style="position: absolute; top: 12px; left: 50%; transform: translateX(-50%); z-index: 1100; background: rgba(255,255,255,0.95); padding: 6px 12px; border-radius: 4px; box-shadow: 0 1px 4px rgba(0,0,0,0.25); display: flex; align-items: center; gap: 12px;"
    >
      <span style="font-size: 13px;">
        Previewing <b>{{ areaPreviewRequest.payload && areaPreviewRequest.payload.name }}</b>
      </span>
      <button type="button" class="btn btn-sm btn-outline-secondary" @click="clearAreaPreviewFromUI">
        Clear preview
      </button>
    </div>
    <div
      v-if="popupVisible"
      class="ol-popup"
      :style="popupStyle"
    >
      <a class="ol-popup-closer" href="#" @click.prevent="closePopup"></a>
      <div v-html="popupHtml"></div>
    </div>
    </div>
    <div v-if="profilingDetailsVisible" class="profiling-details bg-light border-top d-flex flex-column" style="flex: 0 0 40%; min-height: 0;">
      <div class="d-flex flex-grow-1" style="min-height: 0;">
        <div class="profiling-col d-flex flex-column" style="min-width: 0;">
          <div class="d-flex align-items-center px-2 pt-2 pb-1" style="gap: 6px; font-size: 0.78rem;">
            <span class="fw-semibold text-muted me-1">{{ profilingLogScale ? 'ch3 (log)' : 'ch3' }}</span>
            <span class="text-muted">X:</span>
            <input type="number" class="form-control form-control-sm" style="width: 70px;" v-model="profilingRangeCh3Draft.xMin" placeholder="min" @keyup.enter="applyProfilingRangeCh3" />
            <input type="number" class="form-control form-control-sm" style="width: 70px;" v-model="profilingRangeCh3Draft.xMax" placeholder="max" @keyup.enter="applyProfilingRangeCh3" />
            <span class="text-muted ms-1">Y:</span>
            <input type="number" class="form-control form-control-sm" style="width: 80px;" v-model="profilingRangeCh3Draft.yMin" placeholder="min" @keyup.enter="applyProfilingRangeCh3" />
            <input type="number" class="form-control form-control-sm" style="width: 80px;" v-model="profilingRangeCh3Draft.yMax" placeholder="max" @keyup.enter="applyProfilingRangeCh3" />
            <button type="button" class="btn btn-sm btn-primary" @click="applyProfilingRangeCh3" title="Apply ch3 ranges">Apply</button>
            <button type="button" class="btn btn-sm btn-outline-secondary" @click="resetProfilingRangeCh3" title="Reset ch3 ranges">Reset</button>
          </div>
          <div class="px-2 pb-2 flex-grow-1" style="min-height: 0;">
            <VChart v-if="profilingHasCh3" ref="chartCh3" :option="profilingOptionCh3" :update-options="chartUpdateOptions" autoresize class="profiling-chart" />
            <div v-else class="text-muted small">No data</div>
          </div>
        </div>
        <div class="profiling-col d-flex flex-column border-start" style="min-width: 0;">
          <div class="d-flex align-items-center px-2 pt-2 pb-1" style="gap: 6px; font-size: 0.78rem;">
            <span class="fw-semibold text-muted me-1">{{ profilingLogScale ? 'ch4 (log)' : 'ch4' }}</span>
            <span class="text-muted">X:</span>
            <input type="number" class="form-control form-control-sm" style="width: 70px;" v-model="profilingRangeCh4Draft.xMin" placeholder="min" @keyup.enter="applyProfilingRangeCh4" />
            <input type="number" class="form-control form-control-sm" style="width: 70px;" v-model="profilingRangeCh4Draft.xMax" placeholder="max" @keyup.enter="applyProfilingRangeCh4" />
            <span class="text-muted ms-1">Y:</span>
            <input type="number" class="form-control form-control-sm" style="width: 80px;" v-model="profilingRangeCh4Draft.yMin" placeholder="min" @keyup.enter="applyProfilingRangeCh4" />
            <input type="number" class="form-control form-control-sm" style="width: 80px;" v-model="profilingRangeCh4Draft.yMax" placeholder="max" @keyup.enter="applyProfilingRangeCh4" />
            <button type="button" class="btn btn-sm btn-primary" @click="applyProfilingRangeCh4" title="Apply ch4 ranges">Apply</button>
            <button type="button" class="btn btn-sm btn-outline-secondary" @click="resetProfilingRangeCh4" title="Reset ch4 ranges">Reset</button>
          </div>
          <div class="px-2 pb-2 flex-grow-1" style="min-height: 0;">
            <VChart v-if="profilingHasCh4" ref="chartCh4" :option="profilingOptionCh4" :update-options="chartUpdateOptions" autoresize class="profiling-chart" />
            <div v-else class="text-muted small">No data</div>
          </div>
        </div>
        <div class="profiling-meta border-start d-flex flex-column" style="flex: 0 0 240px; min-width: 0;">
          <div class="d-flex align-items-start justify-content-between px-2 pt-2 pb-1" style="gap: 6px;">
            <div class="text-uppercase text-muted" style="font-size: 0.7rem; letter-spacing: 0.04em;">Profiling</div>
            <button type="button" class="btn-close" aria-label="Close" @click="closeProfilingDetails"></button>
          </div>
          <div class="px-2 pb-2" style="font-size: 0.8rem; line-height: 1.35;">
            <div class="text-muted" style="font-size: 0.7rem;">Datetime</div>
            <div class="fw-semibold text-break" style="font-size: 0.85rem;">{{ profilingFormattedTs }}</div>
            <div class="text-muted mt-2" style="font-size: 0.7rem;">Latitude</div>
            <div class="text-break">{{ profilingFormatCoord(profilingSelectedPoint && profilingSelectedPoint.lat) }}</div>
            <div class="text-muted mt-2" style="font-size: 0.7rem;">Longitude</div>
            <div class="text-break">{{ profilingFormatCoord(profilingSelectedPoint && profilingSelectedPoint.lon) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { View, Map } from 'ol';
import OSM from 'ol/source/OSM';
import TileLayer from 'ol/layer/Tile';
import { Image, Heatmap } from 'ol/layer';
import { Point, LineString } from 'ol/geom';
import { Feature } from 'ol';
import { toLonLat, fromLonLat } from 'ol/proj';
import { unByKey } from 'ol/Observable';
import VectorSource from 'ol/source/Vector';
import Cluster from 'ol/source/Cluster';
import XYZ from 'ol/source/XYZ';
import TileWMS from 'ol/source/TileWMS.js';
import {ScaleLine, defaults as defaultControls} from 'ol/control';
// import { Style, Stroke, Fill } from 'ol/style';
// import VectorLayer from 'ol/layer/Vector';
// import WebGLVectorLayer from 'ol/layer/WebGLVector.js';
import ol_source_IDW from '../../source/IDW.js';
import { mapState, mapGetters } from 'vuex';
import 'ol/ol.css';
import { inject, ref, reactive, watch, getCurrentInstance } from 'vue'
import GeoJSON from 'ol/format/GeoJSON.js';
// import ChartsView from './ChartsView';
import { Control } from 'ol/control';
import { registerCapture, unregisterCapture, setCachedCapture, getCachedCapture } from '../../report/captureRegistry';
import VectorLayer from 'ol/layer/Vector';
import { Style, Stroke, Fill, Circle as CircleStyle, Text as TextStyle } from 'ol/style';
import Draw from 'ol/interaction/Draw';
import ColorPalette from '../../components/ColorPalette';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { LineChart } from 'echarts/charts';
import {
  GridComponent,
  TooltipComponent,
} from 'echarts/components';
import VChart from 'vue-echarts';

use([CanvasRenderer, LineChart, GridComponent, TooltipComponent]);

function buildProfilingChartOption(data, color, ranges, logScale) {
  const arr = data || [];
  const r = ranges || {};
  const numOrNull = (v) => (v === '' || v == null || Number.isNaN(Number(v)) ? null : Number(v));
  const xMin = numOrNull(r.xMin);
  const xMax = numOrNull(r.xMax);
  const yMin = numOrNull(r.yMin);
  const yMax = numOrNull(r.yMax);

  // X-диапазон
  let lo = xMin != null ? Math.max(0, Math.floor(xMin)) : 0;
  let hi = xMax != null ? Math.min(arr.length - 1, Math.ceil(xMax)) : arr.length - 1;
  if (hi < lo) [lo, hi] = [hi, lo];
  let viewData = arr.slice(lo, hi + 1);
  let viewIndices = Array.from({ length: viewData.length }, (_, i) => i + lo);

  // log₁₀: сдвиг, чтобы минимум профиля стал 1 — то же преобразование, что
  // apply_scale('log') в idw_processor.py: при неположительных значениях
  // данные сдвигаются (log₁₀(v - min + 1)), иначе log₁₀(v).
  let logShift = 0;
  if (logScale && viewData.length) {
    let min = Infinity;
    for (const v of viewData) {
      if (typeof v === 'number' && Number.isFinite(v) && v < min) min = v;
    }
    if (Number.isFinite(min) && min <= 0) logShift = 1 - min;
  }
  const toLog = (v) => Math.log10(v + logShift);

  // Y-фильтрация (удаление точек вне диапазона) — на сырых значениях
  if (yMin != null || yMax != null) {
    const filteredData = [];
    const filteredIndices = [];
    viewData.forEach((v, idx) => {
      if ((yMin == null || v >= yMin) && (yMax == null || v <= yMax)) {
        filteredData.push(v);
        filteredIndices.push(viewIndices[idx]);
      }
    });
    viewData = filteredData;
    viewIndices = filteredIndices;
  }

  if (logScale) {
    viewData = viewData.map(v =>
      (typeof v === 'number' && Number.isFinite(v)) ? toLog(v) : v
    );
  }

  const yAxis = {
    type: 'value',
    scale: yMin == null && yMax == null,
    axisLabel: {
      showMinLabel: true,
      showMaxLabel: true,
      hideOverlap: true,
      formatter: (v) => {
        if (logScale) return v.toFixed(2);
        const a = Math.abs(v);
        if (a >= 1000) return (v / 1000).toFixed(a >= 10000 ? 0 : 1) + 'k';
        return String(Math.round(v));
      },
    },
  };
  if (yMin != null) {
    const m = logScale ? toLog(yMin) : yMin;
    if (Number.isFinite(m)) yAxis.min = m;
  }
  if (yMax != null) {
    const m = logScale ? toLog(yMax) : yMax;
    if (Number.isFinite(m)) yAxis.max = m;
  }

  return {
    grid: { left: 8, right: 16, top: 16, bottom: 28, containLabel: true },
    xAxis: { type: 'category', data: viewIndices, name: 'sample', nameGap: 18 },
    yAxis,
    tooltip: { trigger: 'axis' },
    series: [{
      type: 'line',
      data: viewData,
      connectNulls: false,
      showSymbol: false,
      lineStyle: { width: 1.2, color },
      itemStyle: { color },
    }],
  };
}

// ResizeObserver-loop suppression is installed in public/index.html so it
// runs before the webpack-dev-server overlay attaches its listeners.

class ScreenshotControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};
    const button = document.createElement('button');
    button.innerHTML = '📸';
    button.title = 'Take a screenshot and share';

    const element = document.createElement('div');
    element.className = 'ol-screenshot ol-control';
    element.appendChild(button);

    super({
      element: element,
      target: options.target,
    });

    button.addEventListener('click', this.handleScreenshot.bind(this), false);
  }

  handleScreenshot() {
    const map = this.getMap();
    if (!map) return;

    const button = this.element.querySelector('button');
    const originalHTML = button.innerHTML;
    button.innerHTML = '⏳';
    button.disabled = true;

    // Даём небольшую задержку для обновления DOM
    setTimeout(() => {
      try {
        const viewport = map.getViewport();
        const canvas = viewport.querySelector('canvas');
        if (!canvas) throw new Error('Canvas not found');

        // Ищем оверлей палитры (обёртку с фоном), а не внутренний контейнер
        const paletteElement = document.querySelector('.map-palette-overlay');

        if (paletteElement && paletteElement.offsetParent !== null) {
          // .signature визуально выходит за высоту .palette-container (height:500px),
          // поэтому offsetHeight оверлея её не учитывает — html2canvas обрезает.
          // Считаем реальную высоту захвата по нижней границе подписи.
          const overlayRect = paletteElement.getBoundingClientRect();
          const signatureEl = paletteElement.querySelector('.signature');
          const captureHeight = signatureEl
            ? Math.max(overlayRect.height, signatureEl.getBoundingClientRect().bottom - overlayRect.top)
            : overlayRect.height;
          const captureWidth = overlayRect.width;
          const dpr = window.devicePixelRatio || 1;

          // Палитра видима – захватываем её и накладываем поверх карты
          import('html2canvas').then(html2canvas => {
            html2canvas.default(paletteElement, {
              backgroundColor: null,
              scale: dpr,
              width: captureWidth,
              height: captureHeight,
              windowWidth: document.documentElement.clientWidth,
              windowHeight: document.documentElement.clientHeight,
            })
              .then(paletteCanvas => this.combineAndDownload(canvas, paletteCanvas, paletteElement, viewport, map, captureWidth, captureHeight))
              .catch(err => {
                console.error('Error capturing palette:', err);
                this.downloadCanvas(canvas, map);
              })
              .finally(() => {
                button.innerHTML = originalHTML;
                button.disabled = false;
              });
          });
        } else {
          // Только карта
          this.downloadCanvas(canvas, map);
          button.innerHTML = originalHTML;
          button.disabled = false;
        }
      } catch (error) {
        console.error('Error creating screenshot:', error);
        alert('Failed to create screenshot. Please try again.');
        button.innerHTML = originalHTML;
        button.disabled = false;
      }
    }, 100);
  }

  combineAndDownload(mapCanvas, paletteCanvas, paletteElement, viewport, map, captureWidth, captureHeight) {
    const combinedCanvas = document.createElement('canvas');
    const ctx = combinedCanvas.getContext('2d');

    combinedCanvas.width = mapCanvas.width;
    combinedCanvas.height = mapCanvas.height;

    ctx.drawImage(mapCanvas, 0, 0);

    // Позиция палитры относительно вьюпорта карты в CSS-пикселях,
    // переводим в пиксели canvas с учётом масштаба карты.
    const viewportRect = viewport.getBoundingClientRect();
    const paletteRect = paletteElement.getBoundingClientRect();
    const scaleX = mapCanvas.width / viewportRect.width;
    const scaleY = mapCanvas.height / viewportRect.height;
    const dx = (paletteRect.left - viewportRect.left) * scaleX;
    const dy = (paletteRect.top - viewportRect.top) * scaleY;
    const dw = captureWidth * scaleX;
    const dh = captureHeight * scaleY;

    ctx.drawImage(paletteCanvas, dx, dy, dw, dh);

    this.addWatermark(ctx, combinedCanvas.width, combinedCanvas.height, map);

    const dataUrl = combinedCanvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.download = `map-screenshot-${Date.now()}.png`;
    link.href = dataUrl;
    link.click();
  }

  downloadCanvas(canvas, map) {
    const tempCanvas = document.createElement('canvas');
    const ctx = tempCanvas.getContext('2d');
    tempCanvas.width = canvas.width;
    tempCanvas.height = canvas.height;
    ctx.drawImage(canvas, 0, 0);
    this.addWatermark(ctx, tempCanvas.width, tempCanvas.height, map);

    const dataUrl = tempCanvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.download = `map-screenshot-${Date.now()}.png`;
    link.href = dataUrl;
    link.click();
  }

  addWatermark(ctx, width, height, map) {
    try {
      if (!map) return;
      const date = new Date().toLocaleString();
      ctx.fillStyle = 'rgba(255, 255, 255, 0.8)';
      ctx.fillRect(10, height - 40, 450, 30);
      ctx.fillStyle = '#000';
      ctx.font = '12px Arial';
      let watermarkText = `Created: ${date} © LIFeLiDAR © OpenStreetMap contributors.`;
      ctx.fillText(watermarkText, 15, height - 20);
    } catch (error) {
      console.error('Error adding watermark:', error);
    }
  }
}

export default {
  name: 'MapContainer',
  components: { ColorPalette, VChart },
  setup() {
    const result = inject('result');
    const idwAction = inject('idwAction');
    const isBathmetry = inject('isBathmetry');
    const isLive = inject('isLive');
    const selected_area = inject('selected_area');
    const redPaletteConfig = inject('redPaletteConfig');
    const greenPaletteConfig = inject('greenPaletteConfig');
    const bluePaletteConfig = inject('bluePaletteConfig');
    const formulae_result1 = inject('formulae_result1');
    const formulae_result2 = inject('formulae_result2');
    const formulae_result3 = inject('formulae_result3');
    const selectedCalRId = inject('selectedCalRId', null);
    const selectedCalGId = inject('selectedCalGId', null);
    const selectedCalBId = inject('selectedCalBId', null);
    const stat = inject('stat');
    const isTrackOn = inject('isTrackOn');
    const isAnimationOn = inject('isAnimationOn');
    const profilingPointsOn = inject('profilingPointsOn', null);
    const profilingFitOn = inject('profilingFitOn', null);
    const profilingPointSize = inject('profilingPointSize', null);

    // Vue 3 auto-unwraps refs returned from setup when accessed via `this.x`,
    // so watch paths like 'profilingPointsOn.value' resolve to undefined and
    // never fire. Wire watchers directly to the refs here.
    const _instance = getCurrentInstance();
    const profilingRefStops = [];
    const _self = () => _instance && _instance.proxy;
    if (profilingPointsOn) {
      profilingRefStops.push(watch(profilingPointsOn, (v) => {
        const s = _self();
        if (s && s.profilingLayer) s.profilingLayer.setVisible(!!v);
      }));
    }
    if (profilingPointSize) {
      profilingRefStops.push(watch(profilingPointSize, () => {
        const s = _self();
        if (s) s.applyProfilingPointStyle();
      }));
    }
    if (profilingFitOn) {
      profilingRefStops.push(watch(profilingFitOn, (v) => {
        if (!v) return;
        const s = _self();
        if (s) s.fitProfilingExtent();
      }));
    }
    const isPalette = inject('isPalette');
    const activePalette = inject('activePalette');
    const selectedPoint = inject('selectedPoint', null);
    const polygonDrawRequest = inject('polygonDrawRequest', null);
    const areaPreviewRequest = inject('areaPreviewRequest', null);
    let animationFrameId = null;

    return {
      map: null,
      popupVisible: ref(false),
      popupCoord: ref(null),
      popupX: ref(0),
      popupY: ref(0),
      popupHtml: ref(''),
      new_view: new View({
        center: fromLonLat([16, 43]),
        zoom: 5,
      }),
      bathmetry_layer: null,
      idwSource: null,
      idw_layer: null,
      heatmap: null,
      isCancelling: false,
      heatmapSource: new VectorSource(),
      redSource: new VectorSource(),
      greenSource: new VectorSource(),
      blueSource: new VectorSource(),
      isClicked: false,
      overlay: null,
      unwatchers: [],
      clickListenerKey: null,
      profilingDragListenerKey: null,
      trackLayer: null,
      // Персистентная линия трека: обновляем её координаты на месте, чтобы
      // live-догрузка точек не пересоздавала слой и не сбивала вид карты.
      trackFeature: null,
      _trackFirstTs: null,
      _trackLastLen: 0,
      result,
      idwAction, 
      isBathmetry,
      isLive,
      selected_area,
      redPaletteConfig,
      greenPaletteConfig,
      bluePaletteConfig,
      formulae_result1,
      formulae_result2,
      formulae_result3,
      selectedCalRId,
      selectedCalGId,
      selectedCalBId,
      stat,
      isTrackOn,
      isAnimationOn,
      profilingPointsOn,
      profilingFitOn,
      profilingPointSize,
      profilingRefStops,
      isPalette,
      activePalette,
      selectedPoint,
      polygonDrawRequest,
      polygonDrawInteraction: null,
      polygonDrawLayer: null,
      polygonDrawSource: null,
      areaPreviewRequest,
      areaPreviewLayers: [],
      animationFrameId,
      popupSnapshots: { map: null, profiling: null },
      profilingRangeCh3: reactive({ xMin: '', xMax: '', yMin: '', yMax: '' }),
      profilingRangeCh4: reactive({ xMin: '', xMax: '', yMin: '', yMax: '' }),
      profilingRangeCh3Draft: reactive({ xMin: '', xMax: '', yMin: '', yMax: '' }),
      profilingRangeCh4Draft: reactive({ xMin: '', xMax: '', yMin: '', yMax: '' }),
      chartUpdateOptions: { notMerge: true, lazyUpdate: false },
      // Live-профайлинг: авто-следование за последней по времени точкой.
      // Сбрасывается при ручном перемещении карты, возобновляется, когда
      // пользователь снова выбирает текущую последнюю точку.
      profilingAutoFollow: true,
      profilingLastFollowedTs: null,
      // appliedAt последнего обработанного полного Search — по его смене
      // отличаем свежую загрузку от инкрементального live-догона.
      profilingFollowAppliedAt: null,
    };
  },
  emits: ['statusDrawing', 'paletteChange'],
  watch: {
    'polygonDrawRequest.active'(active) {
      if (active) {
        this.startPolygonDraw();
      } else {
        this.stopPolygonDraw();
      }
    },
    'areaPreviewRequest.active'(active) {
      if (active) {
        this.renderAreaPreview();
      } else {
        this.clearAreaPreview();
      }
    },
    // Если active уже был true и пользователь повторно жмёт Preview после
    // правок Water mask, .active не меняется — нужно перерендерить по
    // изменению payload, иначе на карте остаётся старая маска.
    'areaPreviewRequest.payload': {
      deep: true,
      handler(payload) {
        if (payload && this.areaPreviewRequest && this.areaPreviewRequest.active) {
          this.renderAreaPreview();
        }
      },
    },
    selectedPoint: {
      deep: true,
      handler(newV) {
        if (!newV || newV.source !== 'chart' || !newV.timestamp) return;
        const point = this.findPointByTime(newV.timestamp);
        if (point && point.coordinates) {
          this.showPopupForPoint(point);
        }
      }
    },
    profilingPoints: {
      deep: true,
      handler() {
        this.refreshProfilingLayer();
        this.maybeFollowLatestProfilingPoint();
      },
    },
    // Heatmap (слой Points) рендерится из this.stat.r/g/b. NavBar.load() мутирует
    // вложенные объекты (this.stat['r'] = response.data), и без явного слежения
    // OpenLayers Heatmap про новые точки не узнаёт — поэтому при повторных Apply
    // (включая Apply после Re-pick polygon) слой оставался устаревшим.
    stat: {
      deep: true,
      handler() {
        if (this.$store.getters.stateIsHeatmap || (this.heatmap && this.heatmap.getVisible())) {
          this.addHeatmapLayer(this.$store.getters.stateIsHeatmap);
        }
      },
    },
    profilingDetailsVisible() {
      this.$nextTick(() => {
        if (this.map) this.map.updateSize();
      });
    },
    profilingSelectedPoint() {
      this.applyProfilingPointStyle();
    },
    isProfilingRoute: {
      immediate: true,
      handler(onProfiling, prev) {
        this.applyProfilingRouteVisibility(onProfiling);
        // The MapContainer instance is reused across /map and /profiling
        // (same component). Snapshot whichever popup is currently visible
        // back into its per-route slot, then restore the slot for the route
        // we're entering. This way popups survive route transitions and the
        // bottom profiling panel re-opens on /profiling automatically.
        if (prev !== undefined && prev !== onProfiling) {
          this.snapshotPopupForRoute(prev ? 'profiling' : 'map');
          this.restorePopupForRoute(onProfiling ? 'profiling' : 'map');
        }
      },
    },
    idwAction(newV, oldV) {
      if(oldV != newV) {
        if(newV === 'start') {
          this.addIDWLayer(true);
        }
        else if(newV === 'cancel') {
          this.stopIDW().catch(error => {
            console.error('Error stopping IDW:', error);
            // Все равно сбросьте состояния даже при ошибке
            this.$emit('statusDrawing', "taskcancelled", 0);
          });
        }
      }
    },
    isBathmetry(newV, oldV) {
      if(oldV != newV) {
        this.toggleBathmetry(newV);
      }
    },
    selected_area(newV) {
      if(newV) {
        if(newV.poly) {
          // const polygonCoords = newV.poly.coordinates[0].map(coord => fromLonLat(coord));
          // const polygon = new Polygon([polygonCoords]);

          // // const polygonStyle = new Style({
          // //   stroke: new Stroke({
          // //     color: 'rgba(0, 0, 255, 0.7)',
          // //     width: 3
          // //   }),
          // //   fill: new Fill({
          // //     color: 'rgba(0, 0, 255, 0.1)'
          // //   })
          // // });

          // // const polygonLayer = new VectorLayer({
          // //   source: new VectorSource({
          // //     features: [new Feature(polygon)]
          // //   }),
          // //   style: polygonStyle
          // // });

          // // this.map.addLayer(polygonLayer);

          // const view = this.map.getView();
          // view.fit(polygon, {
          //   duration: 1000,
          //   padding: [50, 50, 50, 50],
          //   minResolution: 50
          // });
        }
        else {
          this.map.getView().setZoom(5);
          this.map.getView().animate({
            center: fromLonLat([16, 43]),
            duration: 1000,
            zoom: 5
          });
          // this.map.getView().setZoom(5);
        }
      }
    },
    trackPoints: {
      handler() {
        this.refreshTrackLayer();
      },
      deep: true
    },
    'isTrackOn.value'() {
      this.refreshTrackLayer();
    },
    'isAnimationOn.value'() {
      this.refreshTrackLayer();
    }
  },
  computed: {
    ...mapState(['stateResult', 'stateIsHeatmap', 'stateIsIDW', 'stateVs']),
    ...mapGetters(['paramTitles']),
    trackPoints() {
      return this.$store.getters.stateTrackPoints;
    },
    isProfilingRoute() {
      return this.$route && this.$route.name === 'profiling';
    },
    isIDWOn() {
      return !!this.$store.getters.stateIsIDW;
    },
    isHeatmapOn() {
      return !!this.$store.getters.stateIsHeatmap;
    },
    profilingPoints() {
      return this.$store.getters['profilingParams/profilingPoints'] || [];
    },
    profilingSelectedPoint() {
      return this.$store.getters['profilingParams/profilingSelectedPoint'];
    },
    profilingAppliedAt() {
      return this.$store.getters['profilingParams/profilingAppliedAt'];
    },
    profilingDetailsVisible() {
      return this.isProfilingRoute && !!this.profilingSelectedPoint;
    },
    profilingHasCh3() {
      const p = this.profilingSelectedPoint;
      return !!p && Array.isArray(p.profiling_ch3) && p.profiling_ch3.length > 0;
    },
    profilingHasCh4() {
      const p = this.profilingSelectedPoint;
      return !!p && Array.isArray(p.profiling) && p.profiling.length > 0;
    },
    profilingLogScale() {
      return this.$store.getters['profilingParams/profilingLogScale'];
    },
    profilingOptionCh3() {
      const p = this.profilingSelectedPoint;
      return buildProfilingChartOption(p ? p.profiling_ch3 : [], '#1f77b4', this.profilingRangeCh3, this.profilingLogScale);
    },
    profilingOptionCh4() {
      const p = this.profilingSelectedPoint;
      return buildProfilingChartOption(p ? p.profiling : [], '#d62728', this.profilingRangeCh4, this.profilingLogScale);
    },
    profilingFormattedTs() {
      const p = this.profilingSelectedPoint;
      if (!p || !p.ts) return '';
      const d = new Date(p.ts);
      return Number.isNaN(d.getTime()) ? p.ts : d.toISOString().replace('T', ' ').replace(/\.\d+Z$/, ' UTC');
    },
    popupStyle() {
      // position: fixed → coords are viewport-relative.
      // popupX/Y are also stored as viewport-relative (see updatePopupPixel).
      return {
        position: 'fixed',
        left: (this.popupX - 48) + 'px',
        top: (this.popupY - 12) + 'px',
        bottom: 'auto',
        transform: 'translateY(-100%)',
        zIndex: 9999,
        display: 'block',
      };
    }
  },
  created() {
    this.setupWatchers();
  },
  beforeUnmount() {
    unregisterCapture('map');
    unregisterCapture('profiling');
    this.cleanup();
  },
  activated() {
    // keep-alive: пере-регистрируем колбэки на случай, если их перетёрли.
    this.registerReportCaptures();
  },
  deactivated() {
    // Уходя со вкладки, кэшируем снимок ТОЛЬКО когда мы на вкладке Map —
    // снимок для отчёта всегда должен отражать Map, а не Profiling (это один
    // и тот же инстанс карты с разными слоями).
    if (!this.isProfilingRoute) {
      this.captureMapImage().then((url) => setCachedCapture('map', url)).catch(() => {});
    }
  },
  methods: {
    registerReportCaptures() {
      registerCapture('map', () => this.captureMapForReport());
      registerCapture('profiling', () => this.captureProfilingImages());
    },
    // Снимок карты для отчёта всегда берётся со вкладки Map. Карта — общий
    // инстанс OL для роутов /map и /profiling, поэтому: на вкладке Map делаем
    // свежий снимок и кладём его в кэш; на Profiling (или иной вкладке) —
    // возвращаем последний снимок Map из кэша, а не текущий профайлинговый вид.
    async captureMapForReport() {
      if (!this.isProfilingRoute) {
        const url = await this.captureMapImage();
        if (url) setCachedCapture('map', url);
        return url;
      }
      return getCachedCapture('map') || (await this.captureMapImage());
    },
    // Обновляет кэш снимка Map по завершении отрисовки карты (только на вкладке
    // Map), чтобы отчёт, открытый с Profiling, имел актуальный снимок Map.
    cacheMapSnapshotIfOnMap() {
      if (this.isProfilingRoute) return;
      if (this._mapSnapshotPending) return;
      this._mapSnapshotPending = true;
      // Небольшая задержка-троттлинг: не дёргаем toDataURL на каждый кадр.
      setTimeout(() => {
        this._mapSnapshotPending = false;
        if (this.isProfilingRoute) return;
        this.captureMapImage().then((url) => setCachedCapture('map', url)).catch(() => {});
      }, 800);
    },
    // Снимок карты для Print Report: композит всех canvas-слоёв OL в один PNG.
    // Работает и у деактивированного keep-alive компонента — пиксели canvas
    // сохраняют последний отрендеренный кадр. renderSync вызываем только когда
    // карта реально видима, иначе можно затереть кадр нулевым размером.
    // Легенда-палитра в PDF рисуется отдельно (вектором из activePalette),
    // поэтому здесь оверлей не накладываем.
    async captureMapImage() {
      if (!this.map) return null;
      try {
        if (this.$el && this.$el.offsetParent !== null) this.map.renderSync();
      } catch (e) { /* hidden/detached — оставляем последний кадр */ }

      // Размер выходного канваса берём из map.getSize() (CSS-пиксели), как в
      // официальном примере OL "export-map". Это критично: CSS-трансформы
      // слоёв (canvas.style.transform) заданы в CSS-px, и если рисовать в
      // канвас device-px размера, контент смещается «квадратом» в угол.
      const size = this.map.getSize();
      if (!size || !size[0] || !size[1]) return null;
      // Экспортный масштаб для чёткости (ограничиваем, чтобы не раздувать canvas).
      const scale = Math.min(window.devicePixelRatio || 1, 2);
      const outW = Math.round(size[0] * scale);
      const outH = Math.round(size[1] * scale);

      const combined = document.createElement('canvas');
      combined.width = outW;
      combined.height = outH;
      const ctx = combined.getContext('2d');
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, outW, outH);

      const viewport = this.map.getViewport();
      const layerCanvases = viewport.querySelectorAll('.ol-layer canvas, canvas.ol-layer');
      const canvases = layerCanvases.length ? layerCanvases : viewport.querySelectorAll('canvas');
      canvases.forEach((canvas) => {
        if (!canvas.width || !canvas.height) return;
        const parent = canvas.parentNode;
        const opacity = (parent && parent.style && parent.style.opacity) || canvas.style.opacity;
        ctx.globalAlpha = opacity === '' || opacity == null ? 1 : Number(opacity);
        let matrix;
        const transform = canvas.style.transform;
        if (transform) {
          const m = transform.match(/^matrix\(([^)]+)\)$/);
          matrix = m ? m[1].split(',').map(Number) : [1, 0, 0, 1, 0, 0];
        } else {
          matrix = [
            parseFloat(canvas.style.width) / canvas.width, 0, 0,
            parseFloat(canvas.style.height) / canvas.height, 0, 0,
          ];
        }
        // Домножаем CSS-px матрицу на экспортный масштаб, чтобы она ложилась
        // в увеличенный выходной канвас.
        ctx.setTransform(
          matrix[0] * scale, matrix[1] * scale,
          matrix[2] * scale, matrix[3] * scale,
          matrix[4] * scale, matrix[5] * scale
        );
        ctx.drawImage(canvas, 0, 0);
      });
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.globalAlpha = 1;

      this.drawLegendOnCanvas(ctx, size[0], size[1], scale);

      try {
        return combined.toDataURL('image/png');
      } catch (e) {
        console.error('captureMapImage failed:', e);
        return null;
      }
    },
    // Рисует легенду-палитру прямо на снимке карты — так же, как оверлей
    // .map-palette-overlay на экране (вертикальная палитра, числа справа,
    // подпись снизу). Рисуем вектором из activePalette, а не через
    // html2canvas: оверлей может быть откреплён от DOM (keep-alive), когда
    // отчёт экспортируется с другой вкладки. Цвета — RGB-массивы, чисел на
    // одно больше, чем цветов (границы интервалов), порядок снизу вверх.
    drawLegendOnCanvas(ctx, cssW, cssH, scale) {
      const palette = this.activePalette;
      if (!this.isPalette || !this.isIDWOn || !palette) return;
      const colors = Array.isArray(palette.colors) ? palette.colors : [];
      const numbers = Array.isArray(palette.numbers) ? palette.numbers : [];
      if (!colors.length) return;

      const s = scale;
      const W = cssW * s;
      const H = cssH * s;
      const barW = 26 * s;
      const textSize = 13 * s;
      const pad = 8 * s;
      const numGap = 5 * s;
      const barH = Math.min(440 * s, H * 0.55);
      const signature = palette.signature || '';

      ctx.save();
      // Ширина под числа.
      ctx.font = `${textSize}px Arial`;
      let numW = 0;
      numbers.forEach((n) => { numW = Math.max(numW, ctx.measureText(String(n)).width); });

      // Ширина бокса определяется ТОЛЬКО палитрой и числами — подпись не
      // растягивает его (как оверлей на Map). Минимальная ширина задаёт поле,
      // в которое подпись переносится по словам.
      const innerW = Math.max(barW + numGap + numW, 86 * s);
      const boxW = innerW + pad * 2;

      // Перенос подписи по словам в ширину innerW (как .signature width:100%
      // в ColorPalette — текст оборачивается, не расширяя палитру).
      const wrapText = (text, maxW) => {
        const words = String(text).split(/\s+/).filter(Boolean);
        const lines = [];
        let line = '';
        words.forEach((w) => {
          const test = line ? `${line} ${w}` : w;
          if (line && ctx.measureText(test).width > maxW) {
            lines.push(line);
            line = w;
          } else {
            line = test;
          }
        });
        if (line) lines.push(line);
        return lines;
      };
      const lineH = textSize * 1.15;
      const sigLines = signature ? wrapText(signature, innerW) : [];

      const boxH = pad * 2 + barH + (sigLines.length ? 6 * s + sigLines.length * lineH : 0);
      const boxX = W - boxW - 8 * s;
      const boxY = Math.min(110 * s, Math.max(8 * s, H - boxH - 8 * s));

      ctx.fillStyle = 'rgba(255,255,255,0.85)';
      ctx.fillRect(boxX, boxY, boxW, boxH);

      const barX = boxX + pad;
      const barY = boxY + pad + textSize / 2;
      const step = barH / colors.length;
      colors.forEach((c, i) => {
        ctx.fillStyle = Array.isArray(c) ? `rgb(${c.join(',')})` : String(c);
        // colors[0] — нижний блок (как в ColorPalette layout="vertical").
        const top = barY + (colors.length - 1 - i) * step;
        ctx.fillRect(barX, top, barW, step + 0.6);
      });
      ctx.strokeStyle = 'rgba(0,0,0,0.3)';
      ctx.lineWidth = Math.max(1, s);
      ctx.strokeRect(barX, barY, barW, barH);

      ctx.fillStyle = '#222';
      ctx.font = `${textSize}px Arial`;
      ctx.textAlign = 'left';
      ctx.textBaseline = 'middle';
      const numStep = numbers.length > 1 ? barH / (numbers.length - 1) : barH;
      numbers.forEach((n, i) => {
        // numbers[0] — нижняя граница, последняя — верхняя.
        const y = barY + barH - i * numStep;
        ctx.fillText(String(n), barX + barW + numGap, y);
      });

      if (sigLines.length) {
        ctx.textAlign = 'center';
        let sy = barY + barH + 6 * s + lineH / 2;
        sigLines.forEach((ln) => {
          ctx.fillText(ln, boxX + boxW / 2, sy);
          sy += lineH;
        });
      }
      ctx.restore();
    },
    // Снимки графиков профайлинга (ch3/ch4). ECharts getDataURL читает из
    // canvas и работает даже когда панель скрыта (keep-alive).
    captureProfilingImages() {
      const out = [];
      const grab = (ref, title) => {
        const el = this.$refs[ref];
        if (el && typeof el.getDataURL === 'function') {
          try {
            out.push({
              title,
              dataUrl: el.getDataURL({ type: 'png', pixelRatio: 2, backgroundColor: '#fff' }),
            });
          } catch (e) { /* график не готов */ }
        }
      };
      const logSuffix = this.profilingLogScale ? ' (log)' : '';
      if (this.profilingHasCh3) grab('chartCh3', `ch3${logSuffix}`);
      if (this.profilingHasCh4) grab('chartCh4', `ch4${logSuffix}`);
      return out;
    },
    profilingPointsValue() {
      const r = this.profilingPointsOn;
      if (r == null) return true;
      return r.value !== undefined ? !!r.value : !!r;
    },
    profilingFitValue() {
      const r = this.profilingFitOn;
      if (r == null) return false;
      return r.value !== undefined ? !!r.value : !!r;
    },
    profilingPointSizeValue() {
      const r = this.profilingPointSize;
      const raw = r == null ? 5 : (r.value !== undefined ? r.value : r);
      const n = Number(raw);
      return Number.isFinite(n) && n > 0 ? n : 5;
    },
    setupProfilingLayer() {
      this.profilingSource = new VectorSource();
      this.profilingClusterSource = new Cluster({
        source: this.profilingSource,
        distance: 40,
        minDistance: 20,
      });
      this.profilingLayer = new VectorLayer({
        source: this.profilingClusterSource,
        style: (feature) => this.buildProfilingClusterStyle(feature),
        zIndex: 50,
        visible: this.profilingPointsValue(),
      });
      this.map.addLayer(this.profilingLayer);
      this.refreshProfilingLayer();
      this.applyProfilingRouteVisibility(this.isProfilingRoute);
    },
    isProfilingFeatureSelected(feature) {
      const sel = this.profilingSelectedPoint;
      if (!sel || !feature) return false;
      const payload = feature.get('payload');
      if (!payload) return false;
      if (payload === sel) return true;
      // Fallback identity by ts + coords (e.g. after store rehydration).
      return (
        payload.ts === sel.ts &&
        payload.lat === sel.lat &&
        payload.lon === sel.lon
      );
    },
    buildSingleProfilingStyle(feature) {
      const base = this.profilingPointSizeValue();
      const selected = this.isProfilingFeatureSelected(feature);
      const r = selected ? Math.round(base * 1.8) + 2 : base;
      return new Style({
        image: new CircleStyle({
          radius: r,
          fill: new Fill({
            color: selected ? 'rgba(255, 193, 7, 0.95)' : 'rgba(220, 53, 69, 0.85)',
          }),
          stroke: new Stroke({
            color: selected ? '#212529' : '#fff',
            width: selected ? 2.5 : 1.5,
          }),
          zIndex: selected ? 1 : 0,
        }),
        zIndex: selected ? 1 : 0,
      });
    },
    buildProfilingClusterStyle(feature) {
      const features = feature.get('features') || [];
      const size = features.length;
      if (size <= 1) return this.buildSingleProfilingStyle(features[0] || feature);
      const r = Math.min(20, this.profilingPointSizeValue() + 4 + Math.round(Math.log2(size) * 3));
      return new Style({
        image: new CircleStyle({
          radius: r,
          fill: new Fill({ color: 'rgba(220, 53, 69, 0.85)' }),
          stroke: new Stroke({ color: '#fff', width: 1.5 }),
        }),
        text: new TextStyle({
          text: String(size),
          fill: new Fill({ color: '#fff' }),
          font: '600 11px sans-serif',
        }),
      });
    },
    applyProfilingPointStyle() {
      if (!this.profilingLayer) return;
      this.profilingLayer.setStyle((feature) => this.buildProfilingClusterStyle(feature));
    },
    refreshProfilingLayer() {
      if (!this.profilingSource) return;
      this.profilingSource.clear();
      const points = this.profilingPoints || [];
      if (points.length === 0) return;
      const features = points.map((p) => {
        const f = new Feature({ geometry: new Point(fromLonLat([p.lon, p.lat])) });
        f.set('payload', p);
        return f;
      });
      this.profilingSource.addFeatures(features);
      if (this.isProfilingRoute && this.profilingFitValue()) {
        this.fitProfilingExtent();
      }
    },
    // Live-профайлинг: при появлении более свежей последней точки плавно
    // переезжаем к ней, выделяем её и открываем попап — чтобы пользователь
    // сразу видел свежие данные. Работает только в live на вкладке Profiling и
    // пока включено авто-следование (сбрасывается ручным перемещением карты).
    maybeFollowLatestProfilingPoint() {
      if (!this.map || !this.isProfilingRoute || !this.isLive) return;
      const points = this.profilingPoints || [];
      if (!points.length) return;
      const latest = points[points.length - 1];
      if (!latest || latest.ts == null) return;
      // Свежий полный Search/Apply (сменился appliedAt) — начинаем следить с
      // чистого листа: за первичный кадр отвечает fitProfilingExtent, карту не
      // дёргаем, только фиксируем стартовые ts/appliedAt и включаем следование.
      if (this.profilingAppliedAt !== this.profilingFollowAppliedAt) {
        this.profilingFollowAppliedAt = this.profilingAppliedAt;
        this.profilingAutoFollow = true;
        this.profilingLastFollowedTs = latest.ts;
        return;
      }
      // Ничего нового — точка та же, что мы уже показывали.
      if (latest.ts === this.profilingLastFollowedTs) return;
      this.profilingLastFollowedTs = latest.ts;
      if (!this.profilingAutoFollow) return;
      const lat = Number(latest.lat);
      const lon = Number(latest.lon);
      if (!Number.isFinite(lat) || !Number.isFinite(lon)) return;
      this.map.getView().animate({ center: fromLonLat([lon, lat]), duration: 300 });
      this.showProfilingPopup(latest);
      this.$store.dispatch('profilingParams/selectProfilingPoint', latest);
    },
    // Ручной выбор точки: если пользователь сам кликнул текущую последнюю
    // точку — он снова «в синхроне», возобновляем авто-следование. Клик по
    // любой более старой точке — оставляем следование выключенным.
    updateAutoFollowFromManualSelect(payload) {
      if (!this.isProfilingRoute || !this.isLive || !payload) return;
      const points = this.profilingPoints || [];
      const latest = points.length ? points[points.length - 1] : null;
      if (latest && payload.ts === latest.ts) {
        this.profilingAutoFollow = true;
        this.profilingLastFollowedTs = latest.ts;
      } else {
        this.profilingAutoFollow = false;
      }
    },
    fitProfilingExtent() {
      if (!this.map || !this.profilingSource) return;
      const extent = this.profilingSource.getExtent();
      if (extent && extent.every(Number.isFinite)) {
        this.map.getView().fit(extent, { padding: [40, 40, 40, 40], maxZoom: 14, duration: 250 });
      }
    },
    applyProfilingRouteVisibility(onProfiling) {
      // /profiling: hide IDW raster + heatmap (so palette and stale points
      // from Map don't bleed in). Other routes: restore from Vuex flags.
      if (this.idw_layer) {
        this.idw_layer.setVisible(onProfiling ? false : this.isIDWOn);
      }
      if (this.heatmap) {
        this.heatmap.setVisible(onProfiling ? false : this.isHeatmapOn);
      }
      if (this.profilingLayer) {
        this.profilingLayer.setVisible(onProfiling ? this.profilingPointsValue() : false);
      }
    },
    closePopup() {
      this.popupVisible = false;
      this.popupSnapshots = this.popupSnapshots || {};
      this.popupSnapshots[this.isProfilingRoute ? 'profiling' : 'map'] = null;
    },
    closeProfilingDetails() {
      this.$store.dispatch('profilingParams/closeProfilingDetails');
      this.popupVisible = false;
      // Forget the saved Profiling popup so it doesn't reappear on next visit.
      this.popupSnapshots = this.popupSnapshots || {};
      this.popupSnapshots.profiling = null;
    },
    snapshotPopupForRoute(routeKey) {
      this.popupSnapshots = this.popupSnapshots || {};
      this.popupSnapshots[routeKey] = this.popupVisible
        ? {
            coord: this.popupCoord ? [this.popupCoord[0], this.popupCoord[1]] : null,
            html: this.popupHtml,
          }
        : null;
    },
    restorePopupForRoute(routeKey) {
      this.popupSnapshots = this.popupSnapshots || {};
      const snap = this.popupSnapshots[routeKey];
      if (snap && snap.coord) {
        this.popupCoord = snap.coord;
        this.popupHtml = snap.html;
        this.updatePopupPixel();
        this.popupVisible = true;
      } else {
        this.popupVisible = false;
        this.popupHtml = '';
      }
    },
    findNearestProfilingPoint(lon, lat) {
      const points = this.profilingPoints || [];
      if (!points.length) return null;
      // Haversine distance — same approach as findNearestPoint for Map points.
      const R = 6371e3;
      const toRad = (d) => d * Math.PI / 180;
      let best = null;
      let bestDist = Infinity;
      for (const p of points) {
        if (p == null || p.lat == null || p.lon == null) continue;
        const dLat = toRad(p.lat - lat);
        const dLon = toRad(p.lon - lon);
        const a = Math.sin(dLat / 2) ** 2
          + Math.cos(toRad(lat)) * Math.cos(toRad(p.lat)) * Math.sin(dLon / 2) ** 2;
        const dist = R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        if (dist < bestDist) {
          bestDist = dist;
          best = p;
        }
      }
      return best;
    },
    profilingFormatCoord(v) {
      return v == null ? '—' : Number(v).toFixed(6);
    },
    applyProfilingRangeCh3() {
      Object.assign(this.profilingRangeCh3, this.profilingRangeCh3Draft);
    },
    applyProfilingRangeCh4() {
      Object.assign(this.profilingRangeCh4, this.profilingRangeCh4Draft);
    },
    resetProfilingRangeCh3() {
      const empty = { xMin: '', xMax: '', yMin: '', yMax: '' };
      Object.assign(this.profilingRangeCh3Draft, empty);
      Object.assign(this.profilingRangeCh3, empty);
    },
    resetProfilingRangeCh4() {
      const empty = { xMin: '', xMax: '', yMin: '', yMax: '' };
      Object.assign(this.profilingRangeCh4Draft, empty);
      Object.assign(this.profilingRangeCh4, empty);
    },
    startPolygonDraw() {
      if (!this.map || this.polygonDrawInteraction) return;
      this.polygonDrawSource = new VectorSource();
      this.polygonDrawLayer = new VectorLayer({
        source: this.polygonDrawSource,
        style: new Style({
          stroke: new Stroke({ color: 'rgba(0, 0, 255, 0.9)', width: 2 }),
          fill: new Fill({ color: 'rgba(0, 0, 255, 0.15)' }),
        }),
        zIndex: 9999,
      });
      this.map.addLayer(this.polygonDrawLayer);

      this.polygonDrawInteraction = new Draw({
        source: this.polygonDrawSource,
        type: 'Polygon',
      });
      this.polygonDrawInteraction.on('drawend', (evt) => {
        const ring = evt.feature.getGeometry().getCoordinates()[0];
        // Drop the auto-closing duplicate of the first vertex.
        const open = ring.length > 1
          && ring[0][0] === ring[ring.length - 1][0]
          && ring[0][1] === ring[ring.length - 1][1]
          ? ring.slice(0, -1)
          : ring;
        const lonLat = open.map((c) => toLonLat(c));
        if (this.polygonDrawRequest) {
          this.polygonDrawRequest.result = lonLat;
          this.polygonDrawRequest.active = false;
        }
      });
      this.map.addInteraction(this.polygonDrawInteraction);
    },
    stopPolygonDraw() {
      if (this.polygonDrawInteraction) {
        this.map.removeInteraction(this.polygonDrawInteraction);
        this.polygonDrawInteraction = null;
      }
      if (this.polygonDrawLayer) {
        this.map.removeLayer(this.polygonDrawLayer);
        this.polygonDrawLayer = null;
        this.polygonDrawSource = null;
      }
    },
    renderAreaPreview() {
      if (!this.map || !this.areaPreviewRequest || !this.areaPreviewRequest.payload) return;
      this.clearAreaPreview();
      const payload = this.areaPreviewRequest.payload;
      const reader = new GeoJSON({
        dataProjection: 'EPSG:4326',
        featureProjection: 'EPSG:3857',
      });
      const layers = [];
      const allExtents = [];

      // Polygon (area boundary) — semi-transparent red outline.
      if (payload.poly) {
        try {
          const features = reader.readFeatures({ type: 'Feature', geometry: payload.poly });
          const src = new VectorSource({ features });
          const layer = new VectorLayer({
            source: src,
            style: new Style({
              stroke: new Stroke({ color: 'rgba(220, 53, 69, 0.9)', width: 2 }),
              fill: new Fill({ color: 'rgba(220, 53, 69, 0.08)' }),
            }),
            zIndex: 9000,
          });
          this.map.addLayer(layer);
          layers.push(layer);
          allExtents.push(src.getExtent());
        } catch (err) {
          console.error('Failed to render area poly preview:', err);
        }
      }

      // Water mask (GeoJSON FeatureCollection) — blue fill.
      if (payload.water_geojson) {
        try {
          const features = reader.readFeatures(payload.water_geojson);
          if (features.length) {
            const src = new VectorSource({ features });
            const layer = new VectorLayer({
              source: src,
              style: new Style({
                stroke: new Stroke({ color: 'rgba(13, 110, 253, 0.9)', width: 1 }),
                fill: new Fill({ color: 'rgba(13, 110, 253, 0.25)' }),
              }),
              zIndex: 8999,
            });
            this.map.addLayer(layer);
            layers.push(layer);
            allExtents.push(src.getExtent());
          }
        } catch (err) {
          console.error('Failed to render water_geojson preview:', err);
        }
      }

      this.areaPreviewLayers = layers;

      // Fit to combined extent.
      if (allExtents.length) {
        const merged = allExtents.reduce(
          (acc, ext) => [
            Math.min(acc[0], ext[0]),
            Math.min(acc[1], ext[1]),
            Math.max(acc[2], ext[2]),
            Math.max(acc[3], ext[3]),
          ],
          [Infinity, Infinity, -Infinity, -Infinity],
        );
        if (Number.isFinite(merged[0])) {
          this.map.getView().fit(merged, { duration: 500, padding: [60, 60, 60, 60] });
        }
      }
    },
    clearAreaPreview() {
      for (const layer of this.areaPreviewLayers) {
        this.map.removeLayer(layer);
      }
      this.areaPreviewLayers = [];
    },
    clearAreaPreviewFromUI() {
      // Triggered by the floating "Clear preview" button. Flipping the
      // shared flag both removes layers (via the watcher above) and signals
      // NavBar to reopen the edit modal.
      if (this.areaPreviewRequest) {
        this.areaPreviewRequest.active = false;
        this.areaPreviewRequest.payload = null;
      } else {
        this.clearAreaPreview();
      }
    },
    setupWatchers() {
      this.unwatchers = [
        this.$store.watch(
          (_, getters) => getters.stateIsHeatmap,
          this.toggleHeatmap
        ),
        this.$store.watch(
          (_, getters) => getters.stateIsIDW,
          this.toggleIDW
        ),
        this.$store.watch(
          (_, getters) => getters.stateIsDrawing,
          this.addIDWLayer
        ),
        this.$store.watch(
          (_, getters) => getters.stateIdwOpacity,
          this.changeIdwOpacity
        ),
        this.$store.watch(
          (_, getters) => getters.stateIsFit,
          this.toggleFit
        ),
        this.$store.watch(
          (_, getters) => getters.stateIsLoadingData,
          this.loadData
        ),
        this.$store.watch(
          (_, getters) => getters.stateIsServerSideCalc,
          this.toggleServerSideCalc
        )
      ];
    },

    refreshTrackLayer() {
      const points = this.trackPoints;
      const enabled = this.isTrackOn && points && points.length >= 2;

      // Трек выключен или недостаточно точек — сносим слой и анимацию.
      if (!enabled) {
        this.teardownTrackLayer();
        return;
      }

      const lineCoords = points.map(p => fromLonLat([p.lon, p.lat]));

      // Слой уже построен: это инкрементальная догрузка (в т.ч. live) или
      // переприменение того же трека — обновляем ТОЛЬКО геометрию линии, не
      // трогая ни слой, ни вид карты (никаких fit/panTo/setView). Это и есть
      // OL-аналог polyline.setLatLngs(newLatLngs).
      const sameFirst = this.trackFeature
        && this._trackFirstTs != null
        && points[0] && points[0].time === this._trackFirstTs;
      if (this.trackLayer && this.trackFeature && sameFirst) {
        this.trackFeature.getGeometry().setCoordinates(lineCoords);
        this._trackLastLen = points.length;
        return;
      }

      // Новый трек (первое построение или сменившийся диапазон): пересоздаём
      // слой. Центрирование по треку уместно только вне live и только здесь —
      // при live-догрузке ветка выше вид карты не меняет.
      this.teardownTrackLayer();

      const lineFeature = new Feature({
        geometry: new LineString(lineCoords)
      });
      const source = new VectorSource({ features: [lineFeature] });

      let lineStyle;
      if (this.isAnimationOn) {
        lineStyle = new Style({
          stroke: new Stroke({
            color: '#3388ff',
            width: 3,
            lineDash: [10, 10],
            lineDashOffset: 0
          })
        });
      } else {
        lineStyle = new Style({
          stroke: new Stroke({
            color: '#3388ff',
            width: 3
          })
        });
      }

      this.trackLayer = new VectorLayer({
        source,
        zIndex: 4,
        style: lineStyle
      });
      this.trackFeature = lineFeature;
      this._trackFirstTs = points[0] ? points[0].time : null;
      this._trackLastLen = points.length;
      this.map.addLayer(this.trackLayer);

      if (this.isAnimationOn) {
        let dashOffset = 0;
        const animate = () => {
          if (!this.trackLayer) return; // защита от удаления слоя во время анимации
          dashOffset -= 1;
          const resolution = this.map.getView().getResolution();
          const scale = resolution / 10;
          const stroke = this.trackLayer.getStyle().getStroke();
          stroke.setLineDash([10 / scale, 10 / scale]);
          stroke.setLineDashOffset(dashOffset);
          this.trackLayer.changed();
          this.animationFrameId = requestAnimationFrame(animate);
        };
        animate();
      }

      // Подгоняем вид под трек только вне live — в live-режиме пользователь сам
      // управляет положением/зумом, и обновления трека не должны его сбивать.
      if (!this.isLive) {
        const extent = source.getExtent();
        this.map.getView().fit(extent, { duration: 1000, padding: [50, 50, 50, 50], maxZoom: 14 });
      }
    },
    teardownTrackLayer() {
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = null;
      }
      if (this.trackLayer) {
        this.map.removeLayer(this.trackLayer);
        this.trackLayer = null;
      }
      this.trackFeature = null;
      this._trackFirstTs = null;
      this._trackLastLen = 0;
    },
    createFeatures(source, data, result, isHeatmap = false) {
      // Слой Points — показатель наличия/плотности измерений: у всех фич
      // одинаковый вес 1.0. Величина значения формулы в heatmap не отражается
      // (она и так доступна в попапе через 'val'); это устраняет искажения,
      // когда у каналов сильно разный диапазон значений.
      // Каждое значение каждого канала добавляется отдельной фичей: точки,
      // где данные есть только в одном MP, дают один вклад, со всеми тремя —
      // три, что естественно отражает «полноту» точки.
      if (isHeatmap) {
        const features = [];

        // OL Heatmap по умолчанию читает feature.get('weight') и кормит его
        // в WebGL как float-атрибут — поэтому координаты и значения приводим
        // к Number и пропускаем нефинитные, иначе рендер валится с
        // "got a string, but expected number".
        const addChannel = (stat) => {
          if (!stat || !stat.values || !stat.coordinates) return;
          stat.values.forEach((value, index) => {
            const coord = stat.coordinates[index];
            if (!coord) return;
            const lon = Number(coord[0]);
            const lat = Number(coord[1]);
            const v = Number(value);
            if (!Number.isFinite(lon) || !Number.isFinite(lat) || !Number.isFinite(v)) return;
            const f = new Feature(new Point(fromLonLat([lon, lat])));
            f.set('weight', 1);
            // Исходное значение оставляем под 'val' для попапа.
            f.set('val', v);
            features.push(f);
          });
        };

        if (this.$store.getters.stateIsR) addChannel(this.stat.r);
        if (this.$store.getters.stateIsG) addChannel(this.stat.g);
        if (this.$store.getters.stateIsB) addChannel(this.stat.b);

        console.log(`Created ${features.length} heatmap features from stat`);
        features.forEach(f => source.addFeature(f));
        return;
      }
    },

    loadData(isLoading) {
      if (isLoading) {
        if(this.heatmapSource)
          this.heatmapSource.clear();
        if(this.redSource)
          this.redSource.clear();
        if(this.greenSource)
          this.greenSource.clear();
        if(this.blueSource)
          this.blueSource.clear();
      } else {
        // Загрузка только что завершилась — this.stat.r/g/b обновились в NavBar.
        // Без этого вызова слой Points (heatmap) остаётся пустым после первого
        // и стаёт устаревшим после повторного нажатия Apply, потому что
        // toggleHeatmap срабатывает только на изменение stateIsHeatmap.
        if (this.$store.getters.stateIsHeatmap) {
          this.addHeatmapLayer(true);
        }
      }
    },

    adjustViewToFeatures(source) {
      if (source.getFeatures().length === 0) return;
      const extent = source.getExtent();
      this.new_view.fit(extent, {
        size: this.map.getSize(),
        padding: [50, 50, 50, 50]
      });
    },

    addHeatmapLayer(isHeatmap) {
      // hmPointSize приходит из <input type="number"> через v-model без
      // модификатора .number, поэтому в сторе лежит строка. Если передать её
      // прямо в Heatmap.setRadius / new Heatmap({radius}), WebGL-рендер
      // валится с "got a string, but expected number".
      const radius = Number(this.$store.getters.stateHmPointSize) || 5;
      if (this.heatmap) {
        // Очищаем существующие данные
        this.heatmapSource.clear();

        // Создаем новые features из обновленного stat
        this.createFeatures(this.heatmapSource, this.result.data, 'cdom', true);

        this.heatmap.setRadius(radius);
        this.heatmap.changed();
        this.heatmap.setVisible(isHeatmap);
      } else {
        this.heatmapSource.clear();
        this.createFeatures(this.heatmapSource, this.result.data, 'cdom', true);
        this.heatmap = new Heatmap({
          visible: isHeatmap,
          source: this.heatmapSource,
          // Подобрано опытным путём: 1 (как было) — точки булавочные и
          // невидимы при типичных zoom-ах, 15 (дефолт OL) — расплываются
          // в кисель; 5 даёт чёткие, но различимые точки.
          blur: 1,
          radius: radius,
          zIndex: 3,
        });
        this.map.addLayer(this.heatmap);
        this.toggleFit(this.$store.getters.stateIsFit);
      }
    },

    toggleFit(isFit) {
      if (isFit)
        this.adjustViewToFeatures(this.heatmapSource);
    },

    toggleHeatmap(isHeatmap) {
      // /profiling forces the Map's heatmap off regardless of the user's
      // stateIsHeatmap flag — restored when route returns to Map.
      const visible = this.isProfilingRoute ? false : isHeatmap;
      // Каждый раз при включении слоя Points перестраиваем фичи из актуального
      // this.stat. Иначе после повторного Apply (особенно с изменением polygon)
      // в heatmapSource могут остаться устаревшие фичи, и при switch on
      // пользователь увидит старые точки вместо новых.
      if (visible) {
        this.addHeatmapLayer(visible);
        return;
      }
      if(this.heatmapSource.getFeatures().length != 0) {
        this.heatmap.setRadius(Number(this.$store.getters.stateHmPointSize) || 5);
        this.heatmap.setVisible(visible);
      }
      else {
        this.addHeatmapLayer(visible)
      }
    },

    toggleBathmetry(isBathmetry) {
      if(this.bathmetry_layer) {
        this.bathmetry_layer.setVisible(isBathmetry);
      }
      else {
        if(isBathmetry) {
          // GEBCO WMS Layer
          this.bathmetry_layer = new TileLayer({
              source: new TileWMS({
                  url: 'https://wms.gebco.net/mapserv?',
                  params: {
                      'LAYERS': 'GEBCO_LATEST', //GEBCO_LATEST_2',  // GEBCO layer name
                      'VERSION': '1.3.0',       // WMS version
                      'CRS': 'EPSG:3857',        // Use Web Mercator (matches OSM)
                      'FORMAT': 'image/png',
                      'TRANSPARENT': 'true'      // Enable transparency
                  },
                  serverType: 'mapserver',       // Required for MapServer WMS
                  crossOrigin: 'anonymous'
              }),
              opacity: 0.7,  // Adjust opacity to see the base layer
              zIndex: 1
          });
          this.map.addLayer(this.bathmetry_layer);
        }
      }
    },

    changeIdwOpacity(value) {
      if(this.idw_layer)
        this.idw_layer.setOpacity(parseFloat(value));
    },
    toggleServerSideCalc() {

      if (this.idwSource)
        this.idwSource.un('taskstatus', this.handleTask);
        this.idwSource.un('points', this.handlePoints);
        this.idwSource = null;

      // Cleanup vector source
      if (this.redSource) {
        this.redSource.clear();
        this.redSource.dispose();
        this.redSource = new VectorSource();
      }

      // Cleanup vector source
      if (this.greenSource) {
        this.greenSource.clear();
        this.greenSource.dispose();
        this.greenSource = new VectorSource();
      }

      // Cleanup vector source
      if (this.blueSource) {
        this.blueSource.clear();
        this.blueSource.dispose();
        this.blueSource = new VectorSource();
      }
      if(this.idw_layer) {
        this.idw_layer.setMap(null);
        this.idw_layer.dispose && this.idw_layer.dispose();
        this.idw_layer = null;
      }
      
    },

    setOnUn() {
      if(this.$store.getters.stateIsServerSideCalc) {
        this.map.getView().on('change:center', this.doNothing);
        this.map.getView().on('change:resolution', this.doNothing);
        this.map.on('change:size', this.doNothing);
      }
      else {
        this.map.getView().un('change:center', this.doNothing);
        this.map.getView().un('change:resolution', this.doNothing);
        this.map.un('change:size', this.doNothing);
      }

    },

    addIDWLayer(isDrawing) {
      this.$emit('paletteChange', null);
      this.map.getInteractions().forEach((i) => {i.setActive(this.isLive);});
      this.enableZoomButtons(this.isLive);
      const useServerSideCalc = this.$store.getters.stateIsServerSideCalc;
      const maxD = this.$store.getters.stateMaxD ? this.$store.getters.stateMaxD : 10;
      const scale = this.$store.getters.stateScale ? this.$store.getters.stateScale : 10;
      const redScale = this.$store.getters.stateIsLog ? 'log' : 'linear';
      const greenScale = this.$store.getters.stateIsLog ? 'log' : 'linear';
      const blueScale = this.$store.getters.stateIsLog ? 'log' : 'linear';
      const redRange = this.getColorRange('red');
      const greenRange = this.getColorRange('green');
      const blueRange = this.getColorRange('blue');
      const redFilter = this.$store.getters.stateIsRFilter ? { min : this.$store.getters.stateRFilterMin, max : this.$store.getters.stateRFilterMax} : {};
      const greenFilter = this.$store.getters.stateIsGFilter ? { min : this.$store.getters.stateGFilterMin, max : this.$store.getters.stateGFilterMax} : {};
      const blueFilter = this.$store.getters.stateIsBFilter ? { min : this.$store.getters.stateBFilterMin, max : this.$store.getters.stateBFilterMax} : {};
      const redPalette = {
        base_color: this.redPaletteConfig.baseColor,
        num_colors: this.redPaletteConfig.numColors,
        use_palette: !this.$store.getters.stateIsG && !this.$store.getters.stateIsB
      };
      
      const greenPalette = {
        base_color: this.greenPaletteConfig.baseColor,
        num_colors: this.greenPaletteConfig.numColors,
        use_palette: !this.$store.getters.stateIsR && !this.$store.getters.stateIsB
      };
      
      const bluePalette = {
        base_color: this.bluePaletteConfig.baseColor,
        num_colors: this.bluePaletteConfig.numColors,
        use_palette: !this.$store.getters.stateIsG && !this.$store.getters.stateIsR
      };
      const start = this.$store.getters.stateIsCustomData ? this.$store.getters.stateDateStart : this.$store.getters.stateCompleteDateStart;
      const end = this.$store.getters.stateIsCustomData ? this.$store.getters.stateDateEnd : this.$store.getters.stateCompleteDateEnd;
      const avg = this.$store.getters.stateAvgTime ? this.$store.getters.stateAvgTime : 0;
      const is_water_mask = this.$store.getters.stateIsWaterMask;
      const is_live = this.isLive;
      const interval_time = this.$store.getters.stateIntervalTime;
      // Поле "Laser, nm": уходит в /interpolate, бэкенд фильтрует по ell_18_2_pos.
      const laser = this.$store.getters.stateLaser || '';
      if(is_live) {
        if (this.heatmapSource) {
          this.heatmapSource.clear();
        }
        this.stat.r = { values: [], coordinates: [], times: [] };
        this.stat.g = { values: [], coordinates: [], times: [] };
        this.stat.b = { values: [], coordinates: [], times: [] };
      }
      
      if (this.idw_layer && isDrawing) {
        this.idwSource.setScale('red', redScale);
        this.idwSource.setScale('green', greenScale);
        this.idwSource.setScale('blue', blueScale);
        this.idwSource.setMaxD(maxD);
        this.idwSource.setRanges(redRange, greenRange, blueRange);
        this.idwSource.setFilters(redFilter, greenFilter, blueFilter);
        this.idwSource.setPaletteConfig('red', redPalette);
        this.idwSource.setPaletteConfig('green', greenPalette);
        this.idwSource.setPaletteConfig('blue', bluePalette);
        this.idwSource.setIsServerSideCalc(useServerSideCalc);
        this.idwSource.setScaleGlobal(scale);
        this.idwSource.setSources(this.$store.getters.stateIsR ? this.redSource : new VectorSource(),
                                  this.$store.getters.stateIsG ? this.greenSource : new VectorSource(),
                                  this.$store.getters.stateIsB ? this.blueSource : new VectorSource());
        this.idwSource.setTimeRange(start, end);
        this.idwSource.setAvgTime(avg);
        this.idwSource.setIntervalTime(interval_time);
        this.idwSource.setLaser(laser);
        this.idwSource.setIsColor(this.$store.getters.stateIsR, this.$store.getters.stateIsG, this.$store.getters.stateIsB);
        this.idwSource.setIsWaterMask(is_water_mask);
        this.idwSource.setIsLive(is_live);
        this.idwSource.setFormulaes(this.formulae_result1, this.formulae_result2, this.formulae_result3);
        // Передаём актуальные ID калибровочных кривых при повторном Apply —
        // иначе бэкенд продолжит считать с прежней (или нулевой) калибровкой.
        this.idwSource.setCalibrationIds(
          this.selectedCalRId || null,
          this.selectedCalGId || null,
          this.selectedCalBId || null
        );
        if (useServerSideCalc) {
          this.updateIDWLayer();
          this.idwSource.set('changed', false);
          return;
        }
        else
          this.idwSource.setChanged(true);
      }
      else {
        // Verify features have non-zero 'val' values
        this.idwSource = new ol_source_IDW({
          useWorker: false,
          is_cdom: this.$store.getters.stateIsR,
          is_chla: this.$store.getters.stateIsG,
          is_tss: this.$store.getters.stateIsB,
          redSource: this.redSource,
          greenSource: this.greenSource,
          blueSource: this.blueSource,
          weight: 'val',
          scale: scale,
          maxD: maxD,
          projection: 'EPSG:3857', // Explicitly set projection
          redScale: redScale, //'log',      // Logarithmic for red
          greenScale: greenScale,  // Linear (default)
          blueScale: blueScale, //v => Math.sqrt(v) * 2.5  // Custom sqrt scaling
          redRange: redRange,
          greenRange: greenRange,
          blueRange: blueRange,
          redFilter: redFilter,
          greenFilter: greenFilter,
          blueFilter: blueFilter,
          redPalette: redPalette,
          greenPalette: greenPalette,
          bluePalette: bluePalette,
          red_formula: this.formulae_result1,
          green_formula: this.formulae_result2,
          blue_formula: this.formulae_result3,
          useServerSideCalc: useServerSideCalc,
          start_time: start,
          end_time: end,
          avg_time: avg,
          interval: interval_time,
          laser: laser,
          r_filter: {'min' : this.$store.getters.stateRFilterMin, 'max' : this.$store.getters.stateRFilterMax},
          g_filter: {'min' : this.$store.getters.stateGFilterMin, 'max' : this.$store.getters.stateGFilterMax},
          b_filter: {'min' : this.$store.getters.stateBFilterMin, 'max' : this.$store.getters.stateBFilterMax},
          isWaterMask: is_water_mask,
          isLive: is_live,
          // ID выбранных калибровочных кривых для каждого канала;
          // бэкенд применит y=a*x^3+b*x^2+c*x+d к результату формулы.
          calibrationIdR: this.selectedCalRId || null,
          calibrationIdG: this.selectedCalGId || null,
          calibrationIdB: this.selectedCalBId || null,

        });
        this.idw_layer = new Image({
          visible: this.$store.getters.stateIsIDW,
          title: 'IDW',
          source: this.idwSource,
          opacity: parseFloat(this.$store.getters.stateIdwOpacity),
          zIndex: 2
        });
        this.map.addLayer(this.idw_layer);
        // НОВОЕ: Обработка информации о палитрах от источника IDW
        this.idwSource.on('paletteinfo', (event) => {
          this.$emit('paletteChange', event.paletteInfo );
        });
        this.idwSource.on('taskstatus', this.handleTask);
        this.idwSource.on('points', this.handlePoints);
      }
    },

    async stopIDW() {
      try {
        // Сначала сбросьте UI состояния
        this.isDrawing = false;
        this.isStarted = false;
        this.idwText = "Apply";
        
        if (this.idwSource) {
          await this.idwSource._cancelInterpolation();
        }
        
        // Убедитесь, что событие отправлено даже если idwSource недоступен
        this.$emit('statusDrawing', "taskcancelled", 0);
        
      } catch (error) {
        console.error('Error in stopIDW:', error);
        // Все равно уведомляем об отмене
        this.$emit('statusDrawing', "taskcancelled", 0);
      }
    },

    doNothing() {
      if(this.idwSource) {
        if(this.isLive) 
          this.idwSource.setUpdateParams(true);
        this.idwSource.setChanged(true);
      }
    },
    handleTask (event) {
      if (event.status === 'taskcompleted') {
        console.log('Task completed:', event.taskId);
        this.map.getInteractions().forEach((i) => {i.setActive(true);});
        this.enableZoomButtons(true);
        // this.idwSource.setUpdateParams(false);
        // this.idwSource.setChanged(true);
      }
      else if (event.status === 'taskstarted')
        console.log('Task started:', event.taskId);
      else if (event.status === 'taskcancelled') {
        console.log('Task cancelled:', event.taskId);
        this.map.getInteractions().forEach((i) => {i.setActive(true);});
        this.enableZoomButtons(true);
        // this.idwSource.setUpdateParams(false);
        // this.idwSource.setChanged(true);
      }
      this.$emit('statusDrawing', event.status, event.progress);
    },
    enableZoomButtons(isEnabled) {
      const zoomInBtn = document.querySelector('.ol-zoom .ol-zoom-in');
      const zoomOutBtn = document.querySelector('.ol-zoom .ol-zoom-out');
      [zoomInBtn, zoomOutBtn].forEach(btn => {
        if (btn) {
          btn.style.opacity = isEnabled ? '' : '0.5';
          btn.style.pointerEvents = isEnabled ? '' : 'none';
          if (!isEnabled)
            btn.onclick = null; // Remove OL's click handler
        }
      });
    },
    handlePoints(event) {
      if (event.status === 'points_updated') {
        const interval = this.$store.getters.stateIntervalTime;

        // Преобразуем данные в правильный формат для stat
        const newData = event.data;
        // Создаем новые структуры для stat
        const rData = {
          values: [],
          coordinates: [],
          times: [] // если время не приходит, можно использовать текущее время или оставить пустым
        };
        
        const gData = {
          values: [],
          coordinates: [],
          times: []
        };
        
        const bData = {
          values: [],
          coordinates: [],
          times: []
        };
        if(interval != 0) {
          this.stat.r = { values: [], coordinates: [], times: [] };
          this.stat.g = { values: [], coordinates: [], times: [] };
          this.stat.b = { values: [], coordinates: [], times: [] };
        }
        

        // Обрабатываем каждый массив данных
        newData.data.forEach(point => {
          if (point && point.length >= 5) {
            const [lat, lon, rValue, gValue, bValue] = point;
            
            // Добавляем данные для красного канала
            if (this.$store.getters.stateIsR && rValue !== 0) {
              this.stat.r.values.push(rValue);
              this.stat.r.coordinates.push([lon, lat]);
              this.stat.r.times.push(new Date().toISOString()); // или другое время, если доступно
            }
            
            // Добавляем данные для зеленого канала
            if (this.$store.getters.stateIsG && gValue !== 0) {
              this.stat.g.values.push(gValue);
              this.stat.g.coordinates.push([lon, lat]);
              this.stat.g.times.push(new Date().toISOString());
            }
            
            // Добавляем данные для синего канала
            if (this.$store.getters.stateIsB && bValue !== 0) {
              this.stat.b.values.push(bValue);
              this.stat.b.coordinates.push([lon, lat]);
              this.stat.b.times.push(new Date().toISOString());
            }
          }
        });
        // if(interval != 0) {
        //   // Обновляем stat
        //   this.stat.r = rData;
        //   this.stat.g = gData;
        //   this.stat.b = bData;
        // }
        // else
        // {
        //   this.stat.r.push(...rData);
        //   this.stat.g.push(...gData);
        //   this.stat.b.push(...bData);
        // }

        

        console.log('Updated stat:', {
          r: { count: rData.values.length, sample: rData.values.slice(0, 3) },
          g: { count: gData.values.length, sample: gData.values.slice(0, 3) },
          b: { count: bData.values.length, sample: bData.values.slice(0, 3) }
        });

        // Обновляем heatmap
        this.addHeatmapLayer(this.$store.getters.stateIsHeatmap);
      }
    },
    async updateIDWLayer(isUpdateParams) {
      if(this.idwSource) {
        await this.idwSource.updateCanvas(isUpdateParams);
      }
    },
    getColorRange(color) {
      if(color == "red") {
        if (!this.$store.getters.stateIsRRange)
          return null
        const red_min = this.$store.getters.stateIsRRange ? this.$store.getters.stateRMin : null
        const red_max = this.$store.getters.stateIsRRange ? this.$store.getters.stateRMax : null
        return [this.$store.getters.stateIsLog ? Math.log10(1 + red_min) : red_min,
                this.$store.getters.stateIsLog ? Math.log10(1 + red_max) : red_max]
      }
      else if (color == "green") {
        if (!this.$store.getters.stateIsGRange)
          return null
        const green_min = this.$store.getters.stateIsGRange ? this.$store.getters.stateGMin : null
        const green_max = this.$store.getters.stateIsGRange ? this.$store.getters.stateGMax : null
        return [this.$store.getters.stateIsLog ? Math.log10(1 + green_min) : green_min,
                this.$store.getters.stateIsLog ? Math.log10(1 + green_max) : green_max]
      }
      else if (color == "blue") {
        if (!this.$store.getters.stateIsBRange)
          return null
        const blue_min = this.$store.getters.stateIsBRange ? this.$store.getters.stateBMin : null
        const blue_max = this.$store.getters.stateIsBRange ? this.$store.getters.stateBMax : null
        return [this.$store.getters.stateIsLog ? Math.log10(1 + blue_min) : blue_min,
                this.$store.getters.stateIsLog ? Math.log10(1 + blue_max) : blue_max]
      }
    },

    toggleIDW(isIDW) {
      // /profiling forces IDW raster (and thus its palette) off regardless of
      // stateIsIDW — restored when route returns to Map.
      if(this.idw_layer)
      {
        this.idw_layer.setVisible(this.isProfilingRoute ? false : isIDW);
      }
      // this.setDrawingState(false)
    },
    setupPopup() {
      // Ручное перетаскивание карты в live-профайлинге приостанавливает
      // авто-следование за последней точкой (animate() событий pointerdrag не
      // порождает, поэтому программный переезд флаг не сбрасывает).
      this.profilingDragListenerKey = this.map.on('pointerdrag', () => {
        if (this.isProfilingRoute) this.profilingAutoFollow = false;
      });
      this.clickListenerKey = this.map.on('singleclick', evt => {
        try {
          // Когда пользователь рисует polygon (Pick / Re-pick polygon),
          // клик по карте — это вершина полигона, а не запрос попапа.
          // Иначе на каждый клик будет всплывать nearest-point попап и
          // мешать рисованию.
          if (this.polygonDrawInteraction) {
            return;
          }
          // Profiling-mode click: only profiling features may open a popup
          // here. If nothing's hit we explicitly bail — otherwise we'd fall
          // through to the Map-tab nearest-IDW-point logic and surface a
          // Map-style popup on the Profiling tab.
          if (this.isProfilingRoute) {
            const clusterFeature = this.map.forEachFeatureAtPixel(evt.pixel, (f, layer) => {
              return layer === this.profilingLayer ? f : undefined;
            });
            if (clusterFeature) {
              const grouped = clusterFeature.get('features') || [];
              if (grouped.length > 1) {
                // Cluster: zoom in towards it to break it apart.
                const view = this.map.getView();
                const targetZoom = Math.min((view.getZoom() || 0) + 2, 18);
                view.animate({
                  center: clusterFeature.getGeometry().getCoordinates(),
                  zoom: targetZoom,
                  duration: 250,
                });
                return;
              }
              const single = grouped[0] || clusterFeature;
              const payload = single.get('payload');
              if (payload) {
                this.showProfilingPopup(payload);
                this.$store.dispatch('profilingParams/selectProfilingPoint', payload);
                this.updateAutoFollowFromManualSelect(payload);
                return;
              }
            }
            // Click missed every feature: snap to the nearest profiling point
            // by haversine distance — analog of findNearestPoint on the Map tab.
            const [lonClick, latClick] = toLonLat(evt.coordinate);
            const nearest = this.findNearestProfilingPoint(lonClick, latClick);
            if (nearest) {
              this.showProfilingPopup(nearest);
              this.$store.dispatch('profilingParams/selectProfilingPoint', nearest);
              this.updateAutoFollowFromManualSelect(nearest);
            } else {
              this.popupVisible = false;
            }
            return;
          }

          this.isClicked = false;
          const coordinate = evt.coordinate;
          const [lon, lat] = toLonLat(coordinate);
          const near_point_data = this.findNearestPoint(lon, lat);

          if (near_point_data && near_point_data.coordinates) {
            this.showPopupForPoint(near_point_data);
            if (this.selectedPoint && near_point_data.properties && near_point_data.properties.time) {
              this.selectedPoint = {
                timestamp: near_point_data.properties.time,
                source: 'map',
                results: {
                  r: near_point_data.properties.result1,
                  g: near_point_data.properties.result2,
                  b: near_point_data.properties.result3,
                },
                ts: Date.now(),
              };
            }
          }
        }
        catch (error) {
          console.error(error)
        }
      });

      // Re-position popup on every render so it follows pan/zoom/resize.
      this.popupRenderKey = this.map.on('postrender', () => {
        if (this.popupVisible) this.updatePopupPixel();
      });
    },

    updatePopupPixel() {
      if (!this.popupCoord || !this.map) return;
      const pix = this.map.getPixelFromCoordinate(fromLonLat(this.popupCoord));
      const root = this.$refs['map-root'];
      if (pix && root && Number.isFinite(pix[0]) && Number.isFinite(pix[1])) {
        const rect = root.getBoundingClientRect();
        // Convert map-internal pixel to viewport-relative (for position: fixed).
        this.popupX = rect.left + pix[0];
        this.popupY = rect.top + pix[1];
      }
    },

    findNearestPoint(longitude, latitude) {
      function calculateDistance(lat1, lon1, lat2, lon2) {
        const R = 6371e3;
        const φ1 = lat1 * Math.PI / 180;
        const φ2 = lat2 * Math.PI / 180;
        const Δφ = (lat2 - lat1) * Math.PI / 180;
        const Δλ = (lon2 - lon1) * Math.PI / 180;

        const a = Math.sin(Δφ/2) * Math.sin(Δφ/2) +
                  Math.cos(φ1) * Math.cos(φ2) *
                  Math.sin(Δλ/2) * Math.sin(Δλ/2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

        return R * c;
      }

      let nearestPoint = null;
      let minDistance = Infinity;

      // Используем обычный объект вместо Map
      const pointsMap = {};

      // Функция для добавления точек в объект.
      // ВАЖНО: ключ группировки включает time, а не только координаты, потому что
      // при avg_time>0 сервер возвращает несколько time-бакетов с практически
      // одинаковыми усреднёнными координатами — при ключе только по (lon,lat)
      // следующий бакет молча перезаписывал бы значение предыдущего, и при клике
      // на эту координату всплывало бы «последнее» значение независимо от того,
      // какое реально соответствует кликнутой точке.
      const addPointsToMap = (channel, values, coordinates, times, resultKey) => {
        if (values && coordinates) {
          values.forEach((value, index) => {
            if (coordinates[index]) {
              const [lon, lat] = coordinates[index];
              const time = times ? times[index] : null;
              // Между каналами r/g/b точка с одинаковыми (time, lon, lat) — это
              // одно и то же измерение: его нужно мерджить, чтобы в popup-е
              // показались R/G/B вместе. Поэтому в ключе участвуют и время, и
              // координаты с тем же округлением, что и раньше.
              const key = `${time || 'no-time'}|${lon.toFixed(6)},${lat.toFixed(6)}`;

              if (!pointsMap[key]) {
                pointsMap[key] = {
                  coordinates: [lon, lat],
                  properties: {
                    time: time || 'N/A',
                    result1: null,
                    result2: null,
                    result3: null
                  }
                };
              }

              const point = pointsMap[key];
              point.properties[resultKey] = value;
            }
          });
        }
      };

      // Добавляем точки из всех каналов
      if (this.$store.getters.stateIsR && this.stat.r && this.stat.r.values) {
        addPointsToMap('r', this.stat.r.values, this.stat.r.coordinates, this.stat.r.times, 'result1');
      }
      
      if (this.$store.getters.stateIsG && this.stat.g && this.stat.g.values) {
        addPointsToMap('g', this.stat.g.values, this.stat.g.coordinates, this.stat.g.times, 'result2');
      }
      
      if (this.$store.getters.stateIsB && this.stat.b && this.stat.b.values) {
        addPointsToMap('b', this.stat.b.values, this.stat.b.coordinates, this.stat.b.times, 'result3');
      }

      // Ищем ближайшую точку среди всех сгруппированных точек
      Object.keys(pointsMap).forEach(coordKey => {
        const point = pointsMap[coordKey];
        const [lon, lat] = point.coordinates;
        const distance = calculateDistance(latitude, longitude, lat, lon);
        
        if (distance < minDistance) {
          minDistance = distance;
          nearestPoint = {
            ...point,
            distance: distance
          };
        }
      });

      return nearestPoint;
    },
    showProfilingPopup(payload) {
      const lat = Number(payload && payload.lat);
      const lon = Number(payload && payload.lon);
      const tsRaw = payload && payload.ts;
      const tsStr = tsRaw ? new Date(tsRaw).toUTCString() : 'N/A';
      this.popupCoord = [lon, lat];
      this.popupHtml = `
        <table>
          <tr><th>Coordinates:</th><td>${lat.toFixed(4)}, ${lon.toFixed(4)}</td></tr>
          <tr><th>Datetime:</th><td>${tsStr}</td></tr>
        </table>
      `;
      this.updatePopupPixel();
      this.popupVisible = true;
      this.snapshotPopupForRoute('profiling');
    },
    showPopupForPoint(point) {
      this.popupCoord = point.coordinates;
      this.popupHtml = `
        <table>
          <tr><th>Coordinates:</th><td>${point.coordinates[1].toFixed(4)}, ${point.coordinates[0].toFixed(4)}</td></tr>
          <tr><th>Datetime:</th><td>${point.properties.time ? new Date(point.properties.time).toUTCString() : 'N/A'}</td></tr>
          ${point.properties.result1 !== null && point.properties.result1 !== undefined ? `<tr><th style="color:#FF0000">${this.paramTitles[0]}:</th><td>${point.properties.result1.toFixed(4)}</td></tr>` : ''}
          ${point.properties.result2 !== null && point.properties.result2 !== undefined ? `<tr><th style="color:#00FF00">${this.paramTitles[1]}:</th><td>${point.properties.result2.toFixed(4)}</td></tr>` : ''}
          ${point.properties.result3 !== null && point.properties.result3 !== undefined ? `<tr><th style="color:#0000FF">${this.paramTitles[2]}:</th><td>${point.properties.result3.toFixed(4)}</td></tr>` : ''}
        </table>
      `;
      this.updatePopupPixel();
      this.popupVisible = true;
      this.snapshotPopupForRoute('map');
    },
    findPointByTime(targetTimestamp) {
      if (!targetTimestamp) return null;
      const target = new Date(targetTimestamp).getTime();
      if (Number.isNaN(target)) return null;

      const pointsMap = {};
      const collect = (values, coordinates, times, resultKey) => {
        if (!values || !coordinates) return;
        values.forEach((value, index) => {
          if (!coordinates[index]) return;
          const [lon, lat] = coordinates[index];
          const time = times ? times[index] : null;
          const key = time || `${lon.toFixed(6)},${lat.toFixed(6)}`;
          if (!pointsMap[key]) {
            pointsMap[key] = {
              coordinates: [lon, lat],
              properties: { time, result1: null, result2: null, result3: null },
            };
          }
          pointsMap[key].properties[resultKey] = value;
        });
      };

      if (this.stat.r && this.stat.r.values) {
        collect(this.stat.r.values, this.stat.r.coordinates, this.stat.r.times, 'result1');
      }
      if (this.stat.g && this.stat.g.values) {
        collect(this.stat.g.values, this.stat.g.coordinates, this.stat.g.times, 'result2');
      }
      if (this.stat.b && this.stat.b.values) {
        collect(this.stat.b.values, this.stat.b.coordinates, this.stat.b.times, 'result3');
      }

      let nearest = null;
      let minDelta = Infinity;
      Object.values(pointsMap).forEach(point => {
        if (!point.properties.time) return;
        const t = new Date(point.properties.time).getTime();
        if (Number.isNaN(t)) return;
        const delta = Math.abs(t - target);
        if (delta < minDelta) {
          minDelta = delta;
          nearest = point;
        }
      });
      return nearest;
    },
    async cancelDrawing() {
      // Защита от множественных нажатий
      if (this.isCancelling) return;
      
      this.isCancelling = true;
      try {
        this.idwAction = 'cancel';
        this.isDrawing = false;
        this.isStarted = false;
        this.idwText = "Apply";
        
        // Принудительно отправьте событие отмены
        this.$emit('statusDrawing', "taskcancelled", 0);
      } finally {
        // Сбросьте флаг отмены через небольшую задержку
        setTimeout(() => {
          this.isCancelling = false;
        }, 1000);
      }
    },

    cleanup() {
      this.stopIDW();
      // Cleanup event listeners
      if (this.clickListenerKey) {
        unByKey(this.clickListenerKey);
        this.clickListenerKey = null;
      }
      if (this.profilingDragListenerKey) {
        unByKey(this.profilingDragListenerKey);
        this.profilingDragListenerKey = null;
      }
      if (this.popupRenderKey) {
        unByKey(this.popupRenderKey);
        this.popupRenderKey = null;
      }

      // Cleanup store watchers
      this.unwatchers.forEach(unwatch => unwatch());
      this.unwatchers = [];

      // Stop composition-API watchers on injected profiling refs.
      if (Array.isArray(this.profilingRefStops)) {
        this.profilingRefStops.forEach((stop) => { try { stop(); } catch (_) { /* ignore */ } });
        this.profilingRefStops = [];
      }

      // Properly dispose layers
      [this.heatmap, this.idw_layer].forEach(layer => {
        if (layer) {
          layer.setMap(null);
          layer.dispose && layer.dispose();
        }
      });

      if (this.idwSource) {
        this.idwSource.un('taskstatus', this.handleTask);
        this.idwSource.un('points', this.handlePoints);
        this.idwSource.un('paletteinfo', this.handlePoints);
        this.idwSource = null;
        this.idwSource.stopStreaming();
        this.map.getView().un('change', this.updateStreamingParameters);

      }

      // Cleanup vector source
      if (this.redSource) {
        this.redSource.clear();
        this.redSource.dispose();
        this.redSource = null;
      }

      // Cleanup vector source
      if (this.greenSource) {
        this.greenSource.clear();
        this.greenSource.dispose();
        this.greenSource = null;
      }

      // Cleanup vector source
      if (this.blueSource) {
        this.blueSource.clear();
        this.blueSource.dispose();
        this.blueSource = null;
      }

      // Cleanup vector source
      if (this.heatmapSource) {
        this.heatmapSource.clear();
        this.heatmapSource.dispose();
        this.heatmapSource = null;
      }

      // Cleanup map
      if (this.map) {
        this.map.getOverlays().forEach(overlay => overlay.dispose());
        this.map.setTarget(null);
        this.map.dispose();
        this.map = null;
      }

      // Cleanup view
      if (this.new_view) {
        this.new_view.dispose();
        this.new_view = null;
      }

      // Cleanup DOM references
      if (this.$refs.popup) {
        this.$refs.popup.innerHTML = '';
      }
      // Remove entire map container from DOM
      if (this.$refs['map-root']) {
        this.$refs['map-root'].innerHTML = '';
        this.$refs['map-root'].remove();
      }

      if (this.trackLayer && this.map) {
        this.map.removeLayer(this.trackLayer);
        this.trackLayer = null;
      }
      this.trackFeature = null;

      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = null;
      }
    }
  },
  mounted() {
    let layer;

    if (process.env.VUE_APP_MAP_SOURCE === 'local') {
      // Local TileServer-GL
      layer = new TileLayer({
        source: new XYZ({
          url: '/tiles/{z}/{x}/{y}.png',  // Proxy path
        }),
        zIndex: 0
      });
    } else {
      // Default OSM
      layer = new TileLayer({
        source: new OSM(),
        zIndex: 0
      });
    }
    this.map = new Map({
      target: this.$refs['map-root'],
      layers: [
        layer
      ],
      view: this.new_view,
      controls: defaultControls({
        attributionOptions: {
          collapsible: false // Keep attribution always visible
        }
      }).extend([
        new ScaleLine({
          units: 'metric' // or 'imperial'
        }),
        new ScreenshotControl()
      ])
    });
  
    this.setupPopup();
    this.setOnUn();
    this.setupProfilingLayer();
    this.registerReportCaptures();
    // Держим в кэше актуальный снимок вкладки Map для отчёта.
    this.map.on('rendercomplete', this.cacheMapSnapshotIfOnMap);
  }
};
</script>

<style>
  .profiling-chart {
    width: 100%;
    height: calc(100% - 18px);
    min-height: 180px;
  }
  .profiling-col {
    flex: 1 1 0;
  }
  .ol-scale-line {
    position: absolute;
    left: calc(100% - 183px);
    bottom: 20px; /* Adjust based on your attribution height */
    background: rgba(255,255,255,0.7);
    padding: 2px;
  }
  /* Override default zoom control position */
  .ol-zoom {
    top: 8px !important;
    left: auto !important;
    right: 8px !important;
    bottom: auto !important;
  }

  /* Stack buttons vertically */
  .ol-zoom .ol-zoom-in {
    border-radius: 4px 4px 0 0 !important;
  }

  .ol-zoom .ol-zoom-out {
    border-radius: 0 0 4px 4px !important;
  }
  .ol-popup {
    position: absolute;
    background-color: white;
    box-shadow: 0 1px 4px rgba(0,0,0,0.2);
    padding: 15px;
    border-radius: 10px;
    border: 1px solid #cccccc;
    bottom: 12px;
    left: -50px;
    min-width: 340px;
  }
  .ol-popup:after, .ol-popup:before {
    top: 100%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  .ol-popup:after {
    border-top-color: white;
    border-width: 10px;
    left: 48px;
    margin-left: -10px;
  }
  .ol-popup:before {
    border-top-color: #cccccc;
    border-width: 11px;
    left: 48px;
    margin-left: -11px;
  }
  .ol-popup-closer {
    text-decoration: none;
    position: absolute;
    top: 2px;
    right: 8px;
  }
  .ol-popup-closer:after {
    content: "\2715"; /* ✕ – Multiplication X, тоже надёжен */
    font-size: 1.2em;
    line-height: 1;
  }
  .ol-screenshot {
  top: 75px; /* Размещаем под кнопками масштаба */
  right: 8px;
  left: auto;
  }

  .ol-screenshot button {
    display: block;
    margin: 1px;
    padding: 0;
    color: white;
    font-size: 1.14em;
    font-weight: bold;
    text-decoration: none;
    text-align: center;
    height: 1.375em;
    width: 1.375em;
    line-height: .4em;
    background-color: rgba(0,60,136,0.5);
    border: none;
    border-radius: 2px;
    cursor: pointer;
  }

  .ol-screenshot button:hover {
    background-color: rgba(0,60,136,0.7);
  }

  .ol-screenshot button:disabled {
    background-color: rgba(0,60,136,0.3);
    cursor: not-allowed;
  }

  /* Для адаптивности на мобильных устройствах */
  @media (max-width: 768px) {
    .ol-screenshot {
      top: 70px;
      right: 5px;
    }
    
    .ol-screenshot button {
      height: 2em;
      width: 2em;
      font-size: 1.5em;
    }
  }
</style>